"use client";
import React from "react";
import { ArrowLeft } from "lucide-react";
import { ButtonOutline } from "@/components/common/ButtonOutline";

interface AnimatedSidebarPanelProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  headerActions?: React.ReactNode;
}

export function AnimatedSidebarPanel({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  headerActions,
}: AnimatedSidebarPanelProps) {
  return (
    <div
      className={`absolute inset-0 bg-card dark:bg-auth-card transform transition-all duration-300 ease-in-out ${
        isOpen ? "translate-x-0 opacity-100" : "-translate-x-full opacity-0"
      } z-50 overflow-hidden`}
    >
      {/* Header */}
      <div className="p-4 border-b border-border dark:border-auth-background flex items-center space-x-2 animate-slideDown">
        <ButtonOutline
          onClick={onClose}
          className="dark:bg-auth-background dark:border-auth-background hover:bg-primary hover:text-primary-foreground h-8 w-8 p-0 flex items-center justify-center transition-colors shrink-0"
          aria-label="Back"
        >
          <ArrowLeft className="w-4 h-4" />
        </ButtonOutline>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-medium truncate">{title}</h3>
          {subtitle && (
            <p className="text-xs text-muted-foreground truncate">{subtitle}</p>
          )}
        </div>
        {headerActions && <div className="shrink-0">{headerActions}</div>}
      </div>

      {/* Content */}
      <div
        className="h-full overflow-y-auto animate-fadeInUp"
        style={{ height: "calc(100% - 73px)" }}
      >
        {children}
      </div>
    </div>
  );
}
